"use strict"

angular.module("customer")
.service("GoodsTransferService", function($resource, $http, FlashBag, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/inventory/goods-transfers/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.create = function(data) {
        data['source_id'] = data['sourceId'];
        data['destination_id'] = data['destinationId'];
        return (new resource(data)).$save();
    };

    this.query = function(params) {
        return resource.query(params);
    };

    this.get = function(id) {
        var params = {
            id: id
        };
        return resource.get(params);
    };

    this.getAvailableCatalogs = function() {
        return $http.get(appConfig.API_SERVER + "/inventory/goods-transfers/available-catalogs/");
    };

    this.getAvailableProducts = function(catalogId, params) {
        delete params.id;
        return $http({
            url: appConfig.API_SERVER + "/inventory/goods-transfers/available-products/" + catalogId + "/",
            method: "GET",
            params: params
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/goods-transfer/goods-transfer.service.js
// module id = 959
// module chunks = 0